import { Spin, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import CreateCustomerModal from '../../component/customer/CreateCustomerModal';
import CustomerListTable from '../../component/customer/CustomerListTable';
// import ExportListCustomerWithCardAndPartner from '../../component/excel/ExportListCustomerWithCardAndPartner';
import useRole from '../../hook/useRole';
import CustomerResponse from '../../model/Customer.model';
import CustomerService from '../../service/customer-service/Customer.service';

const { Title } = Typography;

const CustomerPage: React.FC = () => {
  const [customerList, setCustomerList] = useState<CustomerResponse[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);

  const role = useRole();

  const fetchCustomerList = async () => {
    try {
      setLoading(true);
      // Fetch all customers regardless of role
      const data = await CustomerService.getCustomerList();

      // Đảm bảo sắp xếp danh sách khách hàng theo thứ tự mới nhất
      if (data) {
        data.sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
      }

      setCustomerList(data || []);
    } catch (error) {
      console.error('Error fetching customers:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomerList();
  }, []);

  return (
    <div className="p-3 md:p-4 max-h-screen">
      <div className="flex flex-col sm:flex-row justify-between sm:items-center mb-4 gap-3 sm:gap-2">
        <Title level={3} className="m-0 text-gray-800">
          Quản lý khách hàng
        </Title>

        <div className="flex flex-wrap items-center gap-2">
          {/* {role === 'ROLE_ADMIN' && (
            // <ExportListCustomerWithCardAndPartner className="w-full sm:w-auto" />
          )} */}

          <CreateCustomerModal
            onSuccess={() => {
              fetchCustomerList();
              setOpenModal(false);
            }}
            openModal={openModal}
            setOpenModal={setOpenModal}
          />
        </div>
      </div>
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <Spin size="large" />
        </div>
      ) : (
        <CustomerListTable
          customerList={customerList}
          onSuccess={fetchCustomerList}
        />
      )}
    </div>
  );
};

export default CustomerPage;
